import { useState } from 'react';
import { faqData } from '@/mocks/dramas';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-question-answer-line text-secondary-500 text-lg"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">常见问题</h2>
          </div>
          <p className="text-sm text-foreground-500">关于天天影院的常见疑问，这里都有答案</p>
        </div>
        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => toggleFaq(index)}
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-200 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-200 ${
                  openIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}